
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"49","height":"49","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24.499","cy":"24.957","r":"24.026","fill":"#fff"}}),_c('path',{attrs:{"d":"M19.9 32.168a1 1 0 001.504.864l10.32-6.013a1 1 0 000-1.728l-10.32-6.013a1 1 0 00-1.504.864v12.026z","fill":"#000C1F"}})])
          )
        }
      }
    